<template>
  <v-row>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card class="elevation-0 rounded-0 fill-height">
        <v-toolbar
            dark
            class="noprint modal-header-gradient"
            >
            <v-btn
                icon
                class="modal-close-btn"
                @click="dialog= false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="font-weight-bold">
                <v-icon left>mdi-comment-text-outline</v-icon>
                Student Result Remarks Entry
            </v-toolbar-title>
        </v-toolbar>
        <v-stepper v-model="e1" flat>
            <v-stepper-header>
            <v-stepper-step
                :complete="e1 > 1"
                step="1"
            >
                Fetch Records
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                :complete="e1 > 2"
                step="2"
            >
                Update Record
            </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
            <v-stepper-content step="1">
                <v-card
                flat
                class="mb-8 pa-4"
                color="#fff"
                >
                    <!-- Search Form -->
                    <find-remark-record :classes="classes" :terms="terms" :authToken="authToken" :accessToken="accessToken" :school="school" @students="studentRecords" @parameterId="selectedTerm" @clasxId="selectedClass"/>

                </v-card>

                <v-btn
                :disabled="!fetchF"
                color="primary"
                rounded
                elevation="2"
                class="px-6"
                @click="step2"
                >
                Continue
                <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>

                <v-btn outlined rounded class="ml-2" @click="dialog = false">
                Close
                </v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
                <v-card
                v-if="records"
                flat
                class="mb-8 pa-4"
                color="#fff"
                >
                    <v-card-title>Remarks Entry Form</v-card-title>
                    <v-card-subtitle class="caption">Showing remarks for Class: <strong>{{records.class.class}}</strong> for the <strong>{{records.term.term_session}}</strong> Term Academic Session</v-card-subtitle>

                    <v-alert border="left" color="black" dismissible type="info" text>
                        Leave blank for students you dont want to record remarks for
                    </v-alert>

                    <remark-entry v-if="reRenderComponent" :students="students" :records="records.data" @updatedRemarkRecords="updatedRemarks"/>

                </v-card>

                <v-btn
                color="primary"
                rounded
                elevation="2"
                class="px-6"
                @click="updateRemarks"
                >
                    <v-icon left>mdi-content-save</v-icon>
                    Save &amp; Close
                </v-btn>
                <v-btn outlined rounded class="ml-2" @click="e1 = 1">
                    <v-icon left>mdi-chevron-double-left</v-icon>
                    Back
                </v-btn>
                <v-btn outlined rounded class="ml-2" @click="e1 = 1">
                    <v-icon left>mdi-refresh</v-icon>
                    New Entry
                </v-btn>
            </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios';
import FindRemarkRecord from './FindRemarkRecord.vue';
import RemarkEntry from './RemarkEntry.vue';
    export default {
    components: { FindRemarkRecord, RemarkEntry },
        name: 'RemarkModal',
        props:[
            'authToken', 
            'accessToken', 
            'school',
            'terms',
            'classes',
        ],
        data () {
            return {
                e1: 1,
                dialog: true,
                records: null,
                fetchF:false,
                storeF:true,
                students:null,
                parameter_id:null,
                clasx_id:null,
                student_ids:null,
                remarkData:{
                    remarks:null
                },
                reRenderComponent:true
            }
        },
        computed:{
           //
        },
        methods: {
            fetchRemarks (){
                let loader = this.$loading.show()
                axios.get(process.env.VUE_APP_BASEURL+'/remarks?school_id='+this.school.school_id+'&clasx_id='+this.clasx_id+'&parameter_id='+this.parameter_id,
                {
                    headers: 
                    {
                        'Authorization': 'Bearer '+this.authToken,
                        'X-Access-Token': this.accessToken,
                    }
                })
                .then((response) => {
                    this.records =  response.data        
                })
                .catch((error) => {
                    this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                        timeout: 5000
                    });
                })
                .finally(() => {
                    loader.hide()
                });
            },
            updateRemarks (){
                if(confirm("Empty Students Remarks will not be saved. Are you sure you want to continue?")){
                    let loader = this.$loading.show()
                    axios.post(process.env.VUE_APP_BASEURL+'/remarks?school_id='+this.school.school_id+'&clasx_id='+this.clasx_id+'&parameter_id='+this.parameter_id,this.remarkData,
                    {
                        headers: 
                        {
                            'Authorization': 'Bearer '+this.authToken,
                            'X-Access-Token': this.accessToken,
                        }
                    })
                    .then((response) => {
                        this.$toast.success('Remarks Saved Successfully', {
                            timeout: 5000
                        });
                        this.e1 = 1
                        console.log(response.data.success)       
                    })
                    .catch((error) => {
                        this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                            timeout: 5000
                        });
                    })
                    .finally(() => {
                        loader.hide()
                    });
                }
            },
            studentRecords (value){
                this.students = value
            },
            selectedTerm (value){
                this.parameter_id = value
            },
            selectedClass (value){
                this.clasx_id = value
                this.fetchF = true
            },
            updatedRemarks (value){
                this.remarkData.remarks = value
            },
            step2 (){
                this.reRenderComponent = false;
                this.$nextTick(() => {
                // Add the component back in
                this.reRenderComponent = true;
                });
                this.fetchRemarks()
                this.e1 = 2
            }
        }
  }
</script>

<style scoped>

</style>